import { render, staticRenderFns } from "./MediaPosts.vue?vue&type=template&id=a2bd0426&scoped=true&"
import script from "./MediaPosts.vue?vue&type=script&lang=js&"
export * from "./MediaPosts.vue?vue&type=script&lang=js&"
import style0 from "./MediaPosts.vue?vue&type=style&index=0&id=a2bd0426&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bd0426",
  null
  
)

export default component.exports